"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerSizes = void 0;
var spinnerSizes = {
  MEDIUM: 'medium',
  LARGE: 'large'
};
exports.spinnerSizes = spinnerSizes;